import Dom from '../base/mdom.js';
import * as Base from '../base/mbase.js';
import * as Strings from '../base/string.js';
var mapToStr = Strings.mapToStr,
    strToMap = Strings.strToMap;
import wxBridge from '../jsbridge/jsbridge_login_queue.js';
import'../jsapis/openUrlWithExtraWebview.js';
import'../jsapis/openGameWebView.js';
import'../jsapis/openWeApp.js';
import'../jsapis/getGameCommInfo.js';
import'../jsapis/openGameUrlWithExtraWebView';
import'../jsapis/openGameTabHome';
import'../jsapis/enableGameView';
import'../jsapis/openCustomWebview';
import'../jsapis/openFinderView';
import '../jsapis/openFinderTopicView';
import '../jsapis/startGameLifeConversation';
import '../jsapis/openGameLifeChatroom';

import env from '../common/env.js';
import quality from '../quality/quality_report_16145.js';
import Dialog from '../common/uiutil.popup.src.js';
import throttle from 'lodash.throttle'; // 这个依赖很小，后面节流实现尽量使用这个库，不要自己再造轮子了
import Grant from '../common/grant';
import UIAlert from '../common/uiutil.popup.src'
import ajaxcall from "../common/ajaxcall";
import report11332 from '../report/11332_batch';

var STATUS_BAR_STYLE = {
    BLACK:'black',
    WHITE:'white'
}

var getQueryStr = Base.getQueryStr;

var checkIsWepkgInUrl = function(url){
    var isInUrl = !!getQueryStr('wechat_pkgid',url);
    return isInUrl;
}

const getonlinelive = (finderusername) => {
    return new Promise(resolve => {
        if( !finderusername ) {
            resolve();
            return;
        }
        ajaxcall("https://game.weixin.qq.com/cgi-bin/gamelivewap/getonlinelive", {
            method: "POST",
            finder_username: finderusername
        }, res => {
            if( res?.errcode === 0 ) {
                resolve(res?.data?.finder_export_id)
            }else {
                resolve()
            }
        }, resolve)
    })
}

const WeVideoMap = {
    "profile": {
        "api": "openFinderView",
        "params": {
            "action": 'openFinderProfile',
            "finderUserName": "finderusername"
        },
        "isSupport": () => {
            let version = env.getHexClientVersion();
            /**
            * 客户端支持版本：
                iOS > 0x17000F00
                安卓 [0x27001338, 0x2700135F] [0x27001500, ]
            */
           if( env.isiOS && version > 0x17000F00 ) { // 
                return true;
            }else if( env.isAndroid && (
                (version >= 0x27001338 && version <= 0x2700135F) || version >= 0x27001500
            )){
                return true;
            }
            return false;
        }
    },
    "feed": {
        "api": "openFinderView",
        "params": {
            "action": 'openFinderFeed',
            "feedID": "feedid",
            "nonceID": "nonceid",
            "sessionId": "sessionid"
        },
        "isSupport": () => {
            let version = env.getHexClientVersion();
            /**
            * 客户端支持版本：
                iOS > 0x17000F00
                安卓 [0x27001338, 0x2700135F] [0x27001500, ]
            */
           if( env.isiOS && version > 0x17000F00 ) { // 
                return true;
            }else if( env.isAndroid && (
                (version >= 0x27001338 && version <= 0x2700135F) || version >= 0x27001500
            )){
                return true;
            }
            return false;
        }
    },
    "live": {
        "api": "openFinderView",
        "params": {
            "action": 'autoOpenFinderLive',
            "finderUserName": "finderusername"
        },
        "isSupport": () => {
            let version = env.getHexClientVersion();
            /**
             * 客户端支持版本
             * iOS：0x17001228
             * 安卓：[0x2700143c, 0x2700145f]  [0x270014b0, 0x270014b1] [0x27001500, 0x2fffffff] 
             * 
            */
            if( env.isiOS && version >= 0x17001228 ) { // 7.0.18.40版本支持
                return true;
            }else if( env.isAndroid && (
                ( version >= 0x2700143c && version <= 0x2700145f ) ||
                ( version >= 0x270014b0 && version <= 0x270014b1 ) || 
                ( version >= 0x27001500 )
            )){
                return true;
            }
            return false;
        },
        async redirect(params) {
            // 实时查直播间
            if( !params.finderUserName ) {
                return ''
            }
            let finderUserName = decodeURIComponent(params.finderUserName)
            let exportId = await getonlinelive(finderUserName);
            if( exportId ) {
                return `https://channels.weixin.qq.com/web/pages/live?eid=${encodeURIComponent(exportId)}`
            }else {
                return `https://channels.weixin.qq.com/web/pages/profile?username=${finderUserName}`
            }
        }
    },
    "livelist": {
        "api": "openFinderView",
        "params": {
            "action": 'openFinderMultiMoreLive',
            "selectTabId": "tab",
            "selectSecondTabId": "subtab",
            "byPass": "bypass",
            "mpPath": "mp_path",
            "envVersion": "env_version"
        },
        "isSupport": () => {
            let version = env.getHexClientVersion();
            /**
             * 客户端支持版本
             * iOS：0x18000700
             * 安卓：0x2800063a
             * 
            */
            if (env.isiOS && version >= 0x18000700 ) { 
                return true;
            } else if (env.isAndroid && version >= 0x2800063a) {
                return true;
            }
            return false;
        }
    },
    "topic": {
        "api": "openFinderTopicView",
        "params": {
            "eventEncryptedTopicId": 'topicid',
            "topicType": "topictype",
            "poiClassifyId": "poiclassifyid",
            "longitude": "longitude",
            "latitude": "latitude",
            "title": "title"
        },
        "isSupport": () => {
            let version = env.clientVersion(true);
            /**
             * 客户端支持版本
             * andorid 8.0.10
             * iOS: 7.0.20
             * 
            */
            if (env.isiOS && env.versionCompare(version, '7.0.20') >= 0) {
                return true;
            } else if (env.isAndroid && env.versionCompare(version, '8.0.10') >= 0) {
                return true;
            }
            return false;
        }
    }
}

const WeGamelifeMap = {
    "chatpage": {
        "api": "startGameLifeConversation",
        "params": {
            "fromUserName": "from_username",
            "toUserName": "to_username",
            "reportInfo": 'report_info',
            "extInfo": 'ext_info'
        },
        "isSupport": () => {
            let version = env.getHexClientVersion();
            /**
             * 客户端支持版本
             * iOS：0x17001000
             * 安卓：0x27001100
             * 
            */
            if (env.isiOS && version < 0x17001000) {
                return Promise.resolve(false);
            } else if (env.isAndroid && version < 0x27001100) {
                return Promise.resolve(false);
            }
            return OpenUrlToolFn.checkIsSupportNativeChat();
        }
    },

    "chatroom": {
        "api": "openGameLifeChatroom",
        "params": {
            "chatroom_name": "chatroom_name",
            "sourceid": "source_id",
            "ssid": "ssid",
            "is_auto_join": "is_auto_join",
            "targetChannelId": "target_channel_id",
            "targetSeq": "target_seq",
            "is_real_time": "is_real_time",
            "extInfo": "ext_info"
        },
        "isSupport": () => {
            let version = env.getHexClientVersion();
            /**
             * 客户端支持版本
             * iOS：0x18000820
             * 安卓：0x28000600
             * 
            */
            if (env.isiOS && version < 0x18000820 ) {
                return Promise.resolve(false);
            } else if (env.isAndroid && version < 0x28000600) {
                return Promise.resolve(false);
            }
            return OpenUrlToolFn.checkIsSupportNativeChat();
        }
    }
}

const defaultWeGameTabConfig = {
    "api": "openGameTabHome",
    "params": {
        "sourceid": "source_id",
        "ssid": "ssid",
    },
    "isSupport": () => {
        return true;
    }
}
const WeGameTabMap = {
    "home": defaultWeGameTabConfig,
    "gameindex": defaultWeGameTabConfig,
    "community": defaultWeGameTabConfig,
    "chat": defaultWeGameTabConfig
}

const EnvVersionMap = {
  release: 0,
  dev: 1,
  trial: 2,
};

const ImmersiveParams = ["wechat_immersive", "immersivePageBgIsDark", "immersiveUIStyle"];

var OpenUrlToolFn = {
    /**
     * 过滤url
     *
     * @param {any} url
     * @returns
     */
    filterOpenUrl:function (url) {
        if (url.indexOf('http') == -1) {
            return location.protocol + '//' + url.replace(/^\s*\/\//, '')
        } else {
            // game 域名才做跟随当前页面的协议
            if( OpenUrlToolFn.checkIsGameHostInUrl(url) ) {
                return url.replace(/https?:/, location.protocol);
            }
            // 其他域名的链接不处理。防止出现url是http的链接且不支持https的，但跟随当前页面又会被强制转成https，最终打不开的问题
            return url;
        }
    },
    isPureMiniAppUrl: function(url) {
        // 纯小程序链接，不存在保底H5 url跳转逻辑
        return url.match(/^weapp:\/\/\S+/)
    },
    isPureWeVideoUrl: function(url) {
        return url.match(/^wevideo:\/\/\S+/);
    },
    isPureWeGamelifeUrl: function(url) {
        return url.match(/^wegamelife:\/\/\S+/);
    },
    isPureWeGameTabUrl: function(url) {
        return url.match(/^wegametab:\/\/\S+/);
    },
    /**
     * 保底的跳转函数。
     *
     * @param {any} url
     */
    safeJump:function(context) {

        var url = context.JumpUrl;

        OpenUrlProcessor.reportOpenRateA(context);

        context.openUrlQualityInstance.EndLogic({
            openUrl:{
                res:'goLocation'
            },
            err_msg: context.progress
        });

        // 无法正常打开webview
        // 当url中不带登录态而且没带wechat_redrect的时候给url增加wechat_direct
        if ( !getQueryStr('uin', url)
                && url.indexOf('#wechat_redirect') == -1
        ) {
            url += '#wechat_redirect';
        }

        // 延迟刷新，否则会上报失败
        setTimeout(() => {
            Dom.window.location.href = url;
        }, 200);

    },
    /**
     * 错误定义。
     *
     * @param {any} tip
     * @returns
     */
    resGen:function(tip) {
        var tipMap = {
            'timeout': 'openUrl:fail,getuinkey timeout',
            'oldver': 'openUrl:fail,too old to support jsapi',
            'invalid': 'openUrl:fail,url invalid'
        };

        return {
            err_msg: tipMap[tip]
        }
    },
    /**
     * 只用于安卓，在连续打开多个webview后，微信卡死。
     * 这里通过新的jsapi 获取 当前 打开的webview的数目。
     * 当小于 5个时，允许打开。
     * @param {any} callback
     */
    canOpenNext:function(callback){
        var currentVersion = env.clientVersion( true );
        /**
         * getGameCommInfo 只在6.6.0版本上才有。。
         */
        if( env.versionCompare(currentVersion,'6.6.0') >= 0){
            wxBridge.getGameCommInfo({cmd:10002},function(res){
                if(res.webpageCount){
                    var pageCount = parseInt(''+res.webpageCount);
                    if( pageCount  < 5){
                        callback();
                    }
                }else{
                    Base.log('getGameCommInfo cmd 10002 error');
                    callback();
                }
            });
        }else{
            callback();
        }
    },
    /**
     * 首先使用openGameUrlWithExtraWebView
     * 如果发生错误就使用openUrlWithExtraWebView
     */
    openWebview: function (context, callback) {
        var url = context.JumpUrl || '';
        /**
         * 用老的方法打开。。它的顶部是黑色的。。。
         *
         * @param {any} _url
         * @param {any} cbk
         */
        var openUrlWithExtraWebview = function(_url,cbk){
            context.progress = 'openUrlWithExtraWebview';
            wxBridge.openUrlWithExtraWebview({
                "url": _url,
                "openType": "1",
                "open_game_webview": "1"
            }, function(res) {
                cbk && cbk(res);
            });
        };
        /**
         * 用 游戏自己开发的，game jsapi打开，顶部是白色的。
         *
         * @param {any} _url
         * @param {any} cbk
         */
        var openGameUrlWithExtraWebView = function(_url,cbk){

            if( context.extparam.statusBarStyle != undefined &&
                !(context.extparam.statusBarStyle in STATUS_BAR_STYLE) ){
                console.error(
                    'extparam.statusBarStyle illegal,must be oneof',
                    STATUS_BAR_STYLE
                );
            }

            const hadUseJscore = wxBridge.openGameUrlWithExtraWebView({
                "url": _url,
                "openType": "1",
                "open_game_webview": "1",
                "statusBarColor": context.statusBarColor, //"#ffffff",
                "statusBarStyle": context.statusBarStyle, //"black",
                "useJscore": !!context.useJscore,
                "preInjectData": context.preInjectData || "",
                "popCurrentVc": !!context.extparam.redirect
            }, function(res) {
                // 打开不成功，使用旧打开webview方式
                cbk && cbk(res);
            });
            context.progress = hadUseJscore ? 'jscore' : 'openGameUrlWithExtraWebView';
        };
        /**
         * 这个 useGameOpen 默认为true, 它的唯一 赋值地，在 processContext 里。
         */
        if( !!context.useGameOpen ){
            if (context.extparam.fullscreen == 1) {
                context.progress = 'enableGameView';
                // enableGameView 的回调并不能每次都成功，很大概率会使原页面进入fallback逻辑
                // 所以提前进行清理
                if (context.jTimer && env.isWechat) {
                    clearTimeout(context.jTimer);
                }
                wxBridge.enableGameView({
                    url: url,
                    Orientation: context.extparam.Orientation || 1, // 1 是竖屏，2是横屏
                }, function(res){
                    callback && callback(res);
                })
            } else {
                openGameUrlWithExtraWebView(url,function(res){

                    if (res.err_msg && res.err_msg.indexOf(':ok') == -1) {
                        /**
                         * 响应胖总需求，旧代码 有可能没有verify
                         * openGameUrlWithExtraWebView导致打开失败。
                         * 于是用旧jsapi打开它。
                         */
                        openUrlWithExtraWebview(url,function(_res){
                            callback && callback(_res);
                        });
                    } else {
                        callback && callback(res);
                    }
                });
            }
        }else{
            openUrlWithExtraWebview(url,function(res){
                callback && callback(res);
            });
        }
    },
    calWeichatPkgid:function(url){
        url = url.replace(/\?.+$, ''/)
        // 通过发布系统的页面都遵循这个规则
        const normalStaticUrl = /https?:\/\/game\.weixin\.qq.com\/cgi-bin\/[^/]+?\/static\//
        // 不符合规则的，先保证页面不报错。并且不符合规则的一般是活动页，活动页不需要wepkg
        if (!normalStaticUrl.test(url)) {
            return ''
        }

        var moduleName = '';
        try {
            moduleName = url.match(/\/cgi-bin\/([^/]+)/)[1];
        } catch (error) {}

        var pkgId = url
            .replace(
                normalStaticUrl,
                ''
            )
            .replace(/\.html.*?$/, '')
            .replace(/\//g, '_')
            .replace(/\-/g, '_');
        if (moduleName !== 'h5') {
            // 如果不是h5下面的模块，就带上模块名
            pkgId = `${moduleName}__${pkgId}`;
        }

        return pkgId;
    },
    checkIsCloseWepkgInUrl(url) {
        var nowepkg = !!getQueryStr('nowepkg',url);
        return nowepkg;
    },
    checkIsGameHostInUrl(url) {
        var regexp = /\/\/game\.weixin\.qq\.com/;
        return !!regexp.test(url)
    },
    /**
     * 检测是否支持跳转视频号页面
     
     */
    getWeVideoActionFromUrl(url) {
        let result = /^wevideo:\/\/([a-z]+)\?/.exec(url);
        if( !result ) {
            return
        }
        if( result[1] in WeVideoMap ) {
            return result[1]
        }
        return;
    },
    checkIsSuppportJumpWeVideo(type) {
        let wevideo = WeVideoMap[type];
        return wevideo.isSupport();
    },
    getWeVideoParamsFromUrl(type, url) {
        let wevideoParams = WeVideoMap[type].params;
        let params = {};
        Object.keys(wevideoParams).forEach(key => {
            if( key === 'action' ) {
                params[key] = wevideoParams[key];
            }else {
                let value = getQueryStr(wevideoParams[key], url);
                if( value ) {
                    params[key] = decodeURIComponent(value)
                }
            }
        });
        return params;
    },
    checkIsSupportNativeChatFromJSAPI() {
        return new Promise((resolve, reject) => {
            wxBridge.verifyJsapi(["getGameCommInfo"], () => {
                wxBridge.invoke(
                    'getGameCommInfo',
                    {
                        cmd: 10010,
                    },
                    (res) => {
                        res = typeof res === 'string' ? JSON.parse(res) : res;
                        let isDisable = res.disable_gamelife_api === false ? false : true;
                        try {
                            localStorage.setItem('_is_support_native_chat_v3', isDisable ? '0' : '1');
                        } catch (error) {}
                        resolve(!isDisable);
                    }
                );
            })
        });
    },
    checkIsSupportNativeChat() {
        return new Promise((resolve, reject) => {
            let result = localStorage.getItem('_is_support_native_chat_v31');
            if (result === '1') {
                resolve(true);
            } else if (result === '0') {
                resolve(false);
            } else {
                return resolve(OpenUrlToolFn.checkIsSupportNativeChatFromJSAPI());
            }

            OpenUrlToolFn.checkIsSupportNativeChatFromJSAPI();
        });
    },
    checkIsSupportJumpNativeGamelife(type) {
        let wegamelife = WeGamelifeMap[type];
        return wegamelife.isSupport();
    },  
    getWeGamelifeActionFromUrl(url) {
        let result = /^wegamelife:\/\/([a-z]+)\?/.exec(url);
        if( !result ) {
            return
        }
        if( result[1] in WeGamelifeMap ) {
            return result[1]
        }
        return;
    },
    getWeGamelifeParamsFromUrl(type, url, context) {
        let wegamelifeParams = WeGamelifeMap[type].params;
        let params = {};
        Object.keys(wegamelifeParams).forEach(key => {
          // 优先取开发者传递的
          if( context?.extparam && wegamelifeParams[key] in context?.extparam ) {
            params[key] = context.extparam[wegamelifeParams[key]];
          }else {
            params[key] = decodeURIComponent(getQueryStr(wegamelifeParams[key], url))
          }
        });
        return params;
    },
    // 检测是否通过gamewebview打开
    checkIsOpenByGameWebview(context) {
        /* 2021.7.21修改： 
        因iOS发现跳转到其他域名页面，会导致登录授权等逻辑出现问题。
        经评估，理论上非game域名页面不会去使用到也不应该使用gamewebview的能力，并且非game域名页面跳转非gamewebview的非核心路径，最坏的情况也可接受。
        因此，将非game域名的统一禁止使用gamewebview打开
        */ 
        if ( !OpenUrlToolFn.checkIsGameHostInUrl(context.srcurl) ) {
          if( /^https?:\/\//.test(context.srcurl) ) {
            // 添加非game域名链接跳转上报
            quality.StartRuner('openUnsafeGameHostUrl', {}).EndLogic({
              err_msg: context.srcurl
            })
            return false
          }
        } 
        if( Math.random() * 100 < 1 ) { // game域名抽样1%上报
          quality.StartRuner('OpenGameHostUrl', {}).EndLogic({
            err_msg: context.srcurl
          })
        }
        if (context.extparam.useGameOpen != undefined) {
            return context.extparam.useGameOpen;
        } else if( env.isMinigame() || ( env.isAndroid && !env.isLuggage)) { 
            /*
            1、小游戏内嵌使用非gamewebview打开
            2、安卓非luggage
            */ 
            return false
        }else {
            return true
        }
    },
    getWeTabActionFromUrl(url) {
        let result = /^wegametab:\/\/([a-z]+)\??/.exec(url);
        if( !result ) {
            return
        }
        if( result[1] in WeGameTabMap ) {
            return result[1]
        }
        return;
    },
    getWeTabParamsFromUrl(type, url, context) {
        let wegametabParams = WeGameTabMap[type].params;
        let params = {};
        Object.keys(wegametabParams).forEach(key => {
          // 优先取开发者传递的
          if( context?.extparam && wegametabParams[key] in context?.extparam ) {
            params[key] = context.extparam[wegametabParams[key]];
          }else {
            params[key] = decodeURIComponent(getQueryStr(wegametabParams[key], url))
          }
        });
        return params;
    },
};


var OpenUrlProcessor = {
    /**
     * 预处理一下url
     *
     * @param {Object} context
     * @returns 修改后的 context
     */
    urlPretreatment:function(context){
        context.JumpUrl = OpenUrlToolFn.filterOpenUrl(context.srcurl);
        context.JumpUrl = context.JumpUrl.replace(/#wechat_redirect/g, '');

        /**
         * 强制传递abt
         */
        var abt     = getQueryStr('abt',null,top);
        var currAbt = getQueryStr('abt',context.srcurl) || 0;
        /**
         * 如果目标url中 有abt=，那就使用当前 url中的abt
         * 否则不做替换操作。继续用 当前页面里的abt
         */
        if( !!currAbt ){
            abt = currAbt;
        }

        context.extparam.abt = context.extparam.abt || abt;
        // noticeid透传逻辑：开发者指定参数、跳转目标里面的url
        // 20220830 去掉上级页面的透传逻辑 https://tapd.woa.com/wechat11/prong/stories/view/1010079491877133235
        var noticeid = context.extparam.noticeid ||  getQueryStr('noticeid',context.srcurl);
        if( noticeid ) {
            context.extparam.noticeid = noticeid;
        }
        let source_id = context.extparam.source_id || getQueryStr('source_id',context.srcurl);
        if( source_id && /^\d+$/.test(source_id) ) { // 防止传递过来的source_id不对
            context.extparam.source_id = source_id;
        }

        var param = context.extparam;
        param.ssid = param.ssid || 0;
        param.abt  = param.abt  || 0;

        // 20230109 业务经常没传ssid，导致上报会无法区分具体来源，二跳时保底加个999999，将这部分量统计到站内来算
        if( !param.ssid && !param.source_id ) {
            param.source_id = 999999
        }

        /*
        * 对历史的调用用做一次修正，把ssid的值赋给sourceid。
        * 暂不去掉ssid，因为有版本普及问题，直接去掉ssid，可能会导致下一个页面基础库不是最新的，导致sourceid上报丢失
        */ 
        // 暂时去掉此修正逻辑，如果下一个页面的上报协议不是11332，会有坑
        // if( !param.source_id && param.ssid > 100 ) { 
        //     param.source_id = param.ssid; 
        // }

        let extInfo = param.extInfo || param.ext_info;
        if( extInfo ) {
            if (typeof extInfo === 'string') {
                try {
                    extInfo = JSON.parse(decodeURIComponent(extInfo));
                } catch (e) {
                    extInfo = {};
                }
            }
            // 传给客户端的需要为json字符串
            param.ext_info = JSON.stringify(extInfo);
            delete param.extInfo;
        }

        // 支持preInjectData传递
        if( param.preInjectData ) {
          if( typeof param.preInjectData !== 'object' ) {
            console.error("preInjectData is not a object");
          }else {
            context.preInjectData = JSON.stringify(param.preInjectData);
            if( !env.canPreInjectDataUse() && !env.isCSR) {
              param.pij_d_k = Base.unikey();
              localStorage.setItem(`pij_d_k_${param.pij_d_k}`, context.preInjectData)
            }
          }
          delete param.preInjectData;
        }

        /*
            平台侧增加rpt_allpath参数记录用户访问具体路径
            如果传入了ssid，组件自动完成rpt_allpath的拼接

            如果没有带ssid，也需要将之前的rpt_allpath拼接 2017/12/5
        */
        var allPathTemp = [];
        if (getQueryStr('rpt_allpath')) {
            allPathTemp.push(getQueryStr('rpt_allpath'))
        }
        if (param.source_id) {
            // let scene = Dom.window?.WXGAME?.Env?.getScene?.(); // 通过env获取scene
            // if( scene ) {
            //     allPathTemp.push(`${scene}-${param.ssid}`);
            // }else {
            //     allPathTemp.push(param.ssid);
            // }
            allPathTemp.push(param.source_id);
        }else if( param.ssid ) {
            allPathTemp.push(param.ssid);
        }
        if(allPathTemp.length > 0){
            param.rpt_allpath = allPathTemp.join('_')
        }

        /**
         * 为从活动跳转到平台 做个兼容逻辑。因为活动传过来的ssid
         */
        if( (''+param.ssid).indexOf('act') === 0 ){
            param.ssid = param.ssid.replace('act','');
        }

        /** 为了兼容小程序进入webview的bug，需要透传参数 isFromWeappEntry */
        if (getQueryStr('isFromWeappEntry') ) {
            param.isFromWeappEntry = getQueryStr('isFromWeappEntry');
        }

        var spliter = context.JumpUrl.indexOf('?') != -1 ? '&' : '?';
        /** 依次从param、url、location.href 取 */
        var closeWepkg = !!param.closeWepkg || OpenUrlToolFn.checkIsCloseWepkgInUrl(context.JumpUrl) || OpenUrlToolFn.checkIsCloseWepkgInUrl(location.href);

        /** 去除一些功能性能数 。与URL无关的 */
        var wantDeleteParam = {
            'closeWepkg':1,
            'useGameOpen':1,
            'statusBarStyle':1,
            'statusBarColor':1,  //特别是这个，它影响hash值
            'useJscore': 1
        };
        for(var p in wantDeleteParam ){
            delete param[p];
        }

        var isWepkgUrl = checkIsWepkgInUrl(context.JumpUrl);
        /**前端强制加上wepkgid .
         * 会误伤一些旧的wepkgid，但没事，重新打包一下它。
         */

        if( !closeWepkg && !isWepkgUrl ){

            var newWepkgId = OpenUrlToolFn.calWeichatPkgid(context.JumpUrl);
            if( newWepkgId ){
                param['wechat_pkgid'] = encodeURIComponent(newWepkgId);
            }
        }
        
        param['from_wechat_pkgid'] = getQueryStr('wechat_pkgid') || '';

        /** 需要关闭wepkg，做以下事情
         * 1. 透传nowepkg=1
         * 2. 去掉wechat_pkgid参数
        */
        if( closeWepkg ) {
            context.JumpUrl = Base.removeQueryStringKey("nowepkg", context.JumpUrl);
            context.JumpUrl = Base.removeQueryStringKey("wechat_pkgid", context.JumpUrl);
            delete param['wechat_pkgid'];
            param['nowepkg'] = 1;
        }

        // 先删除一下url里面的沉浸式相关的参数，统一删除后由下面的逻辑决定是否启用
        ImmersiveParams.forEach((key) => {
            context.JumpUrl = Base.removeQueryStringKey(key, context.JumpUrl);
        });

        // 沉浸式体验，根据globalConfig配置决定是否开启 - https://git.code.oa.com/WGFE/commlib/issues/18
        if (Dom.window?.WXGAME?.GlobalConfig?.router?.checkNeedImmersiveParamInUrl(context.JumpUrl) ) { 
            ImmersiveParams.forEach((key) => {
                param[key] = 1;
            });
        }

        // 小游戏实名透传参数
        if( env.isMinigame()) {
            param.AppServiceType = Base.getQueryStr("AppServiceType") || undefined;
            param.menuButtonBoundingClientRect = Base.getQueryStr("menuButtonBoundingClientRect") || undefined;
            param.versionType = Base.getQueryStr('versionType') || undefined;
            param.is_real_name = env.isRealName();
        }


        if( Base.getQueryStr("darkmode") === '1' ) {
            param.darkmode = 1;
        }

        var url     = context.JumpUrl + spliter + mapToStr(param);

        context.extparam    = param;
        context.allPathTemp = allPathTemp;
        /**
         * 严重warning 如果是URL中有wepkgid ，那就不能加#wechat_redirect;
         * PC微信不加
         */
        if( !checkIsWepkgInUrl( url ) && !env.isPcWechat){
            context.JumpUrl     = url + (url.slice(-1)[0] == '#' ? '' : '#') + 'wechat_redirect';
        } else {
            context.JumpUrl     = url;
        }

        return context;
    },
    /**
     * 为跳转到 小程序 提供支持。
     * 注意它的规范，要html
     * @param {any} context
     * @returns
     */
    processMiniApp:function(context){
        /*
            demo链接：https://game.weixin.qq.com/cgi-bin/h5/competition/index.html?gameid=xxx&roomid=xxx&weapp=weapp%3A%2F%2Fwx98bb879bbb53ad81%3Fenv_version%3Dtrial%26path%3Dpages%252Findex%252Findex%253Fid%253D123#wechat_redirect
            如果url中带有webapp的参数，那就优先先拉起小程序，如果失败的再跳转url
        */
        var isPureMiniAppUrl = OpenUrlToolFn.isPureMiniAppUrl(context.srcurl);
        var JumpUrl = isPureMiniAppUrl ? context.srcurl : OpenUrlToolFn.filterOpenUrl(context.srcurl);
        var extparam = context.extparam;
        var allPathTemp = context.allPathTemp;

        if (   JumpUrl.indexOf(encodeURIComponent('weapp://')) != -1
            || JumpUrl.indexOf('weapp://') != -1) {
            // 小游戏未实名
            if( env.isMinigame() && !env.isRealName()) {
                if(env.onRealNameRequestFns.length > 0) {
                    env.onRealNameRequestFns.forEach(fns => fns());
                    return true;
                }
            }
            if( env.isMiniprogram()) {
                UIAlert.alert('请前往「发现>游戏」中\n获取更多信息', {
                    confirmTxt: "知道了"
                });
                return true;
            }

            // 带有兼容H5地址的小程序地址格式
            var miniapp_url = '',
                miniapp_param = {};

            if (isPureMiniAppUrl) {
                miniapp_url = context.srcurl;
            } else {
                miniapp_url = decodeURIComponent(getQueryStr('weapp', JumpUrl))
            }

            // 获取weapp
            miniapp_url = miniapp_url.replace(/weapp:\/\/([\d\w]+)/g, function(match, p1) {
                miniapp_param.targetAppId = p1;
                return '';
            });

            // 小程序路径地址加入ssid，使得小程序可以得到来源场景id
            miniapp_param.path = decodeURIComponent(getQueryStr('path', miniapp_url))
            if (extparam.ssid) {
                miniapp_param.path += (miniapp_param.path.indexOf('?') == -1
                                        ? '?' : '&')
                                        + 'ssid=' + extparam.ssid
                                        + '&rpt_allpath=' + allPathTemp.join('_');
            }
            let currentPageUrl = location.href.replace(/\?{1,}(.*)/,'')
            // 从发现入口进入场景，小程序path带上sessionid，小程序内上报
            const gameSessionId = env.getGameSessionId();
            if (gameSessionId) {
                miniapp_param.path += (miniapp_param.path.indexOf('?') == -1
                    ? '?' : '&')
                    + (gameSessionId ? 'x_wxgame_session=' + encodeURIComponent(gameSessionId) : '');
                currentPageUrl = currentPageUrl + '?session_id=' + encodeURIComponent(gameSessionId)
            }

            // 下一次跳转将不带weapp，走url跳转
            JumpUrl = JumpUrl.replace(/weapp=[^&#]+/g, '');
            let envVersion = getQueryStr('env_version', miniapp_url)
            wxBridge.openWeApp({
                sourceAppId: "wx62d9035fd4fd2059",
                appId : miniapp_param.targetAppId,
                relativeURL        : miniapp_param.path,
                openType  : envVersion in EnvVersionMap ? EnvVersionMap[envVersion] : 0,
                scene: 1055, // 1055 为H5来源
                sceneNote: currentPageUrl,
            }, function(res) {
                // 成功拉起小程序，直接回调
                if (res.err_msg.indexOf(':ok') != -1) {
                    // 因业务会判断err_msg.indexOf("launchMiniProgram")>-1做上报逻辑，需兼容
                    context.callback({
                        err_msg: 'launchMiniProgram:ok'
                    });
                } else {
                    // 走H5跳转,JumpUrl已经去掉weapp，不会造成循环，然后传入回调

                    if (isPureMiniAppUrl) {
                        // 没有保底地址逻辑，需要提示
                        if (res.err_msg.indexOf('clientVersion') != -1) {
                            // 版本问题，提示版本过低
                            context.callback(OpenUrlToolFn.resGen('oldver'))
                        } else {
                            // 其他问题，将错误抛回给业务逻辑处理
                            context.callback(res);
                        }
                    } else {
                        OpenUrlProcessor.reportNoWepkg(context);
                        OpenUrlProcessor.processSafeLogic(context)
                                        .processIos(context)
                                        .processAndroid(context)

                    }
                }
            });

            // 如果是小程序的拉起，防止下面的逻辑进行
            return true;

        }

        return false;
    },
    /**
     * 游戏中心跳转视频号
     * wevideo://profile?finderusername=xxx
     * @param {any} context
     * @returns
    */
    processWeVideo: throttle(function(context) { // 短时间多次调用视频号接口，会有问题（这里业务的实现有可能是click、也有可能是touchstart触发）
        var isPureWeVideoUrl = OpenUrlToolFn.isPureWeVideoUrl(context.srcurl);
        if( !isPureWeVideoUrl ) {
            return false;
        }
        if( !env.isWechat ) { // 非微信，点击无反应，静默
            return true;
        }
        if( env.isMiniprogram() ) {
            UIAlert.alert('请前往「发现>视频号」中\n关注视频号动态', {
                confirmTxt: "知道了"
            });
            return true;
        }
        /*
        * 个人profile页: wevideo://profile?
        * feed流:  wevideo://feed?
        * live直播:  wevideo://live?
        */ 
        let type = OpenUrlToolFn.getWeVideoActionFromUrl(context.srcurl);
        if( !type ) {
            context.callback(OpenUrlToolFn.resGen('invalid'))
            return true;
        } 
        if( OpenUrlToolFn.checkIsSuppportJumpWeVideo(type) ) {
            let params = OpenUrlToolFn.getWeVideoParamsFromUrl(type, context.srcurl);
            let api = WeVideoMap[type].api;
            wxBridge[api](params, context.callback);
        }else {
            Dialog.alert("该内容由视频号提供，当前微信版本过低，无法打开，请更新微信", {
                confirmTxt: "更新微信",
                closeTxt: "取消",
                style: "twoBtn",
                confirmCb() {
                    let url = "https://support.weixin.qq.com/update/";
                    originOpenUrl(url)
                },
                closeCb() {}
            })
        }
        return true;
    }, 1000, {
        trailing: false,
        leading: true
    }),
    /**
     * 游戏中心跳转游戏人生会话
     * wegamelife://chatpage?from_username=&to_username=&session_id=
     * @param {any} context
     * @returns
    */
    processWeGamelife: async function(context) {
        var isPureGamelifeUrl = OpenUrlToolFn.isPureWeGamelifeUrl(context.srcurl);
        if( !isPureGamelifeUrl ) {
            return false;
        }
        if( env.isMiniprogram() ) {
            UIAlert.alert('请前往「发现>游戏>聊天」\n加入小组', {
                confirmTxt: "知道了"
            });
            return true;
        }
        let type = OpenUrlToolFn.getWeGamelifeActionFromUrl(context.srcurl);
        if( !type ) {
            context.callback(OpenUrlToolFn.resGen('invalid'))
            return true;
        } 
        let isSupport = await OpenUrlToolFn.checkIsSupportJumpNativeGamelife(type);
        if( isSupport ) {
            let params = OpenUrlToolFn.getWeGamelifeParamsFromUrl(type, context.srcurl, context);
            let api = WeGamelifeMap[type].api;
            if( wxBridge[api] ) {
                wxBridge[api](params, context.callback)
            }
        }else {
            Dialog.alert("该内容由微信游戏人生提供，当前微信版本过低，无法打开，请更新微信", {
                confirmTxt: "更新微信",
                closeTxt: "取消",
                style: "twoBtn",
                confirmCb() {
                    let url = "https://support.weixin.qq.com/update/";
                    originOpenUrl(url)
                },
                closeCb() { }
            })
        }
        return true;
    },
    processWeGameTab: throttle(function(context) {
        var isPureGameTabUrl = OpenUrlToolFn.isPureWeGameTabUrl(context.srcurl);
        if( !isPureGameTabUrl ) {
            return false
        }
        if( env.isMiniprogram() ) {
            UIAlert.alert('请前往「发现>游戏」\n查看详情', {
                confirmTxt: "知道了"
            });
            return true;
        }
        let type = OpenUrlToolFn.getWeTabActionFromUrl(context.srcurl);
        if( !type ) {
            context.callback(OpenUrlToolFn.resGen('invalid'))
            return true;
        } 
        let params = OpenUrlToolFn.getWeTabParamsFromUrl(type, context.srcurl, context);
        let api = WeGameTabMap[type].api;
        if( wxBridge[api] ) {
            wxBridge[api]({
                tabKey: type,
                ...params
            }, context.callback)
        }
        return true;
    }),

    /**
     * 分开逻辑，安卓下，以下处理函数。
     *
     * @param {any} context
     * @returns
     */
    processAndroid: throttle(function(context){ // 移动端用了click事件，理论上有300ms延迟，但因为安卓webview打开都比较慢，因此这里需要手动加个节流
        var that = this;
        if ( !env.isAndroid ) {
            return this;
        }
        // 小程序内嵌用location跳转，小游戏内嵌使用webview打开
        if( env.isMiniprogram() && !env.isMinigame()) {
            OpenUrlToolFn.safeJump(context);
            return this;
        }

        function openDone(res) {
            if (context.jTimer) {
                clearTimeout(context.jTimer);
            }
            // 安卓jscore对快速点击操作做了1s节流的控制，会导致res返回的err_msg是undefined，导致badjs报错。先保护一下不报错，后续新基础库再来统一做节流的逻辑
            if (res.err_msg && res.err_msg.indexOf(':ok') == -1) {
                setTimeout(function () {
                    context.callback(res);
                    OpenUrlToolFn.safeJump(context);
                }, 200);
            }else{
                that.reportOpenRateA(context);
                context.callback(res);
            }
        }
        debugger


        /*
        * 如果是 安卓，并且版本大于，6.5.9，并且配置了 gameView 参数。
        */
        var currentVersion = env.clientVersion( true );
        if( env.isAndroid &&
            env.versionCompare(currentVersion,'6.5.9') > 0 &&
            context.extparam.gameView === true)
        {
            context.progress = 'openGameWebView';
            wxBridge.openGameWebView({
                "url": context.JumpUrl
            }, openDone);

            return this;
        }

        /*
        * 其它情况，全部走这一块。并且 如果是安卓时，默认打开gameview
        */
        if (context.extparam.fullscreen == 1 || context.extparam.redirect ) {
            context.progress = 'openCustomWebview';
            var orientation = 'vertical'; // default
            if (context.extparam.Orientation == 2) {
                orientation = 'horizontal'
            }
            wxBridge.openCustomWebview({
                "orientation": orientation,
                "fullscreen": context.extparam.fullscreen == 1 ? true: false,
                "url": context.JumpUrl,
                "open_game_webview": "1",
                "finish_recent_webview": context.extparam.redirect ? '1': '0'
            }, openDone)
        } else {
            context.progress = 'canOpenNext';
            OpenUrlToolFn.canOpenNext(function(){
                OpenUrlToolFn.openWebview(
                    context,
                    openDone
                )
            });
        }

        return this;
    }, 1000, {
        trailing: false,
        leading: true
    }),
    /**
     * 分开逻辑，IOS下，以下处理函数。
     *
     * @param {any} context
     * @returns
     */
    processIos:function(context){
        var that = this;
        if(env.isiOS || env.isPcWechat){
            if( env.isMiniprogram() && !env.isMinigame()) {
                OpenUrlToolFn.safeJump(context);
                return this;
            }
            /*
            * 其它情况，全部走这一块。并且 如果是安卓时，默认打开gameview
            */
            OpenUrlToolFn.openWebview(
                context,
                function (res) {
                    if (context.jTimer) {
                        clearTimeout(context.jTimer);
                    }
                    if (res.err_msg.indexOf(':ok') == -1) {
                        setTimeout(function () {
                            context.callback(res);
                            OpenUrlToolFn.safeJump(context);
                        }, 200);
                    } else {
                        that.reportOpenRateA(context);
                        context.callback(res);
                    }
                }
            );

        }
        return this;
    },
    /**
     * 在以上处理都不成功（超时）后，这个逻辑，自动走一下location.href
     *
     * @param {any} context
     * @returns
     */
    processSafeLogic:function(context){
        // 小游戏webview场景不走该场景
        if( env.isMiniprogram() ) {
            return this;
        }
        // 跳转保底逻辑
        context.jTimer = setTimeout(function() {
            context.callback(OpenUrlToolFn.resGen('timeout'));
            OpenUrlToolFn.safeJump(context)
        },env.isWechat ? 2000 : 500);
        return this;
    },
    processContext:function(srcurl, extparam, callback){
        var context = {};

        context.srcurl   = srcurl + '';
        context.extparam = extparam || {};



        context.callback = typeof callback == 'function' ?
                                                callback :
                                                function() {};
        context.allPathTemp = [];
        context.JumpUrl     = '';
        context.useGameOpen = OpenUrlToolFn.checkIsOpenByGameWebview(context);
        if(undefined != context.extparam.statusBarStyle){
            context.statusBarStyle = context.extparam.statusBarStyle;
        }
        if(undefined != context.extparam.statusBarColor){
            context.statusBarColor = context.extparam.statusBarColor;
        }
        if(undefined != context.extparam.useJscore){
            context.useJscore = context.extparam.useJscore;
        }

        return context;
    },
    // 处理内部重定向情况
    async processRedirection(srcurl) {
        let version = env.getHexClientVersion();
        // 视频号的重定向
        let isPureWeVideoUrl = OpenUrlToolFn.isPureWeVideoUrl(srcurl);
        if(isPureWeVideoUrl) {
            let type = OpenUrlToolFn.getWeVideoActionFromUrl(srcurl);
            let params = OpenUrlToolFn.getWeVideoParamsFromUrl(type, srcurl);
            if(type === 'livelist') {
                // IOS>= 0x17002000全部用小程序打开，安卓>=0x28000b3a用小程序
                if(params.byPass && ((env.isiOS && version >= 0x17001400) || (env.isAndroid && version >= 0x28000b3a))) {
                    let path = '/pages/livecollection/index.html';
                    let version = '';
                    if (params.mpPath) { // 指定了mpPath的话，使用mpPath跳转
                        path = decodeURIComponent(params.mpPath);
                    }
                    if (params.envVersion) { // 指定小程序版本
                        version = `&env_version=${params.envVersion}`;
                    } 
                    srcurl = `weapp://wx4bfd324d7e80de2e?path=${encodeURIComponent(`${path}?bypass=${encodeURIComponent(params.byPass)}`)}${version}`
                }
            }
            // 视频号PC微信，走重定向逻辑
            if( env.isPcWechat && WeVideoMap[type] && WeVideoMap[type].redirect ) {
                srcurl = await WeVideoMap[type].redirect(params)
            }
        }
        return Promise.resolve(srcurl);
    },
    /**
    * 授权逻辑，当需要授权时，拉起半屏弹框，弹框成功回调后再跳转到目标页
    * @param {any} srcurl
    * @param {any} extparam
    * @param {any} callback
    */
    processInfoProtect(srcurl, extparam, callback) {
        let self = this;
        if( extparam.grantInfo && extparam.grantInfo.biz_id === undefined){
            UIAlert.alert('系统出错了');
            return;
        }
        let appid = extparam.grantInfo?.appid || 'wx95a3a4d7c627e07d';
        let biz_id = extparam.grantInfo?.biz_id;
        let is_auth = extparam.grantInfo?.is_auth || false;
        let type = extparam.grantInfo?.type || 1;
        // 拉取授权弹框
        new Grant({
            grantInfo: { // 授权信息对应的数据
                is_auth: is_auth,
                appid: appid,
                biz_id: biz_id,
                type: type
            },
            success(res) { // 点击确认后的回调
                // 正常跳转页面，需要去掉授权信息
                delete extparam.grantInfo;
                originOpenUrl(srcurl, extparam, callback)
            }
        });
        return;
    },
    getRandom:function(context){
        return true;
        //前端不抽样。后台来抽样。
        // var random = Math.floor( Math.random() * 10 );
        // return random === 1 ? true : false;
    },
    stipUrl:function(url){
        return url.replace(/\?{1,}(.*)/,'').replace(/^http(s)?:\/\//,'');
    },
    generateRateKey:function(context){
        var srcurl = context.srcurl;
        /**
         * 1、这里生成一个可解密的 key
         * 2、再生成一个时间差15s
         * */
        var now         = Date.now();
        var url         = this.stipUrl(srcurl);
        var currentUrl  = this.stipUrl(Dom.window.location.href);

        try{
            var key     = 'openRate_' + url;
            var objStr  = JSON.stringify({
                fromUrl : currentUrl,
                time    : now
            })
            localStorage.setItem(key,objStr);
        }catch(e){
            context.openRateInstance.EndLogic({
                err_msg:'generateRateKey_localstorage error'
            });
        }
        return now;
    },
    reportNoWepkg:function(context){
        var url = context.JumpUrl;
        var hasWepkg = checkIsWepkgInUrl(url);
        if( !hasWepkg ){
            url = Strings.getDomainPath(url);
            if( context.openUrlWepkgUrlQualityInstance){
                context.openUrlWepkgUrlQualityInstance.EndLogic({
                    err_msg: url
                });
            }
        }
    },
    reportOpenRateA:function(context){
        var canOpenRate = context.canOpenRate;

        if( canOpenRate ){
            context.openRateInstance.EndLogic({
                err_msg:JSON.stringify({
                    targetUrl   : context.srcurl
                })
            });
        }
    },
    reportJumpInfo: function(context) {
        var currentPkgid = Base.getQueryStr('wechat_pkgid') || '';
        var nextPkgid = OpenUrlToolFn.calWeichatPkgid(context.JumpUrl);

        report11332([{
            iActionId: 30040,
            iOpType: 2,
            sExternInfo: JSON.stringify({
                pkgid: currentPkgid,
                next_pkgid: nextPkgid
            })
        }])
        return this;
    }
};
/**
 * 打开一个URL的基础库。
 *
 * @param {any} srcurl
 * @param {any} extparam
 * @param {any} callback
 * @returns
 */

async function originOpenUrl(srcurl, extparam, callback) {
    var _oSelf = this,
        context = {};
    extparam = extparam || {};

    // 如果url非法，不进行跳转
    var reg = /:?\/\//g
    if (!reg.test(srcurl)) {
        callback && callback(OpenUrlToolFn.resGen('invalid'));
        return;
    }

    /**
     * 个人信息保护处理逻辑，当需要用户授权时，需要拉起半屏弹框而不进行跳转
     */
     if(undefined != extparam.grantInfo){
        OpenUrlProcessor.processInfoProtect(srcurl, extparam, callback);
        return;
     }

    srcurl = await OpenUrlProcessor.processRedirection(srcurl);
    /**
     * 准备一下context里的各种有用的参数。
     */
    context = OpenUrlProcessor.processContext(srcurl, extparam, callback);
    
    /**
     * 这是一个对URL进行预处理用的。比如去hash，加abt,allpath等。
     */
    context = OpenUrlProcessor.urlPretreatment(context);

    /**
     * 再为context增加一下 质量监控实例。
     */
    context.openUrlQualityInstance = quality.StartRuner('openUrl', {
        url: srcurl,
        extparam: extparam
    });


    context.openUrlWepkgUrlQualityInstance = quality.StartRuner('openUrlWepkg', {
        url: srcurl,
        extparam: extparam
    });

    context.openRateInstance = quality.StartRuner('openRateStart', {
        url: srcurl,
        extparam: extparam
    });

    //往缓存里生成一下 key
    context.canOpenRate = OpenUrlProcessor.getRandom();
    if (context.canOpenRate) {
        OpenUrlProcessor.generateRateKey(context);
    }


    /**
     * 先做跳转 小程序支持。
     */
    var isMiniApp = OpenUrlProcessor.processMiniApp(context);
    if (isMiniApp) {
        return;
    }
    var isWeVideo = OpenUrlProcessor.processWeVideo(context);
    if (isWeVideo) {
        return;
    }

    var isWeGamelife = await OpenUrlProcessor.processWeGamelife(context);
    if (isWeGamelife) {
        return;
    }

    var isWeGameTab = await OpenUrlProcessor.processWeGameTab(context);
    if (isWeGameTab) {
        return;
    }

    /*
    *   做打开 目的 URL 中没有 wepkg 的监控。要放在小程序之后。
    *   因为小程序 url 是没有wepkgid 的。
    */

    OpenUrlProcessor.reportNoWepkg(context);

    /*
     * 上报当前页面和目标页面的pkgid，关联计算打开率 
     */    
    OpenUrlProcessor.reportJumpInfo(context);
    /**
     * 分不同平台提供支持。
     */
    OpenUrlProcessor.processSafeLogic(context)
        .processIos(context)
        .processAndroid(context);
};



wxBridge.openUrl = wxBridge.openUrl || originOpenUrl;


// 获取URL类型的方法
const URL_TYPE_ENUM = {
    WEAPP      : 'weapp',
    WEVIDEO    : 'wevideo',
    WEGAMELIFE : 'wegamelife'
}
// 获取链接的跳转场景
export function getUrlType(srcUrl) { 
    // srcUrl = OpenUrlProcessor.processRedirection(srcUrl);
    if(OpenUrlToolFn.isPureMiniAppUrl(srcUrl)) {
        return URL_TYPE_ENUM.WEAPP
    }else if (OpenUrlToolFn.isPureWeVideoUrl(srcUrl)) {
        return URL_TYPE_ENUM.WEVIDEO
    }else if (OpenUrlToolFn.isPureWeGamelifeUrl(srcUrl)) {
        return URL_TYPE_ENUM.WEGAMELIFE
    }
}

getUrlType.enum = URL_TYPE_ENUM;
wxBridge.getUrlType =  wxBridge.getUrlType || getUrlType;

export default wxBridge;
export const openUrl = wxBridge.openUrl;

